export default __webpack_public_path__ + "static/media/dots-icon.e2559a7b.svg";